// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"vu_a bhe_b"};